import { render, staticRenderFns } from "./WebsiteStats.vue?vue&type=template&id=31059854&scoped=true"
import script from "./WebsiteStats.vue?vue&type=script&lang=js"
export * from "./WebsiteStats.vue?vue&type=script&lang=js"
import style0 from "./WebsiteStats.vue?vue&type=style&index=0&id=31059854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31059854",
  null
  
)

export default component.exports